import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SpinnerService {

  // Observable source
  private showFlagSource = new Subject<boolean>();

  // Observable stream
  showFlag$ = this.showFlagSource.asObservable();

  // Service message commands
  setShowFlag(flag: boolean) {
    this.showFlagSource.next(flag);
  }

  // Observable source
  private showSoftFlagSource = new Subject<boolean>();

  // Observable stream
  showSoftFlag$ = this.showSoftFlagSource.asObservable();

  // Service message commands
  setSoftSpinnerShowFlag(flag: boolean) {
    this.showSoftFlagSource.next(flag);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/spinner-service.ts